import {
  Paragraph,
  SectionType,
  TextRun,
  HeadingLevel,
  ExternalHyperlink,
  ISectionOptions,
} from 'docx'
import dateRange from '../common/dateRange'
import { Resume } from '@/types/resume/v1'

const education = ({ education }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Education',
        heading: HeadingLevel.HEADING_2,
      }),
      ...education.reduce<Paragraph[]>((acc, eduItem) => {
        return [...acc, ...createEducationItem(eduItem)]
      }, []),
    ],
  }
}

const createEducationItem = (edu: Resume.Education): Paragraph[] => {
  const item: Paragraph[] = []

  const institutionTextRun = edu.url
    ? new ExternalHyperlink({
      link: edu.url,
      children: [
        new TextRun({
          text: edu.institution,
          bold: true,
        }),
      ],
    })
    : new TextRun({
      text: edu.institution,
      bold: true,
    })

  item.push(
    new Paragraph({
      text: '\n',
    })
  )

  const dateRangeText = dateRange(edu.startDate, edu.endDate)
  const paragraphChildren = [institutionTextRun]

  if (dateRangeText) {
    paragraphChildren.push(
      new TextRun({
        text: '    ' + dateRangeText, // 4 spaces before date
        bold: false,
      })
    )
  }

  item.push(
    new Paragraph({
      children: paragraphChildren,
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: edu.studyType,
          bold: true,
        }),
        new TextRun({
          text: ' ',
        }),
        new TextRun({
          text: edu.area,
        }),
      ],
    })
  )
  if (edu.minors?.length) {
    item.push(
      new Paragraph({
        text: `Minors: ${edu.minors.join(', ')}`,
      })
    )
  }
  if (edu.courses?.length) {
    item.push(
      new Paragraph({
        text: `Courses: ${Array.isArray(edu.courses.length)
            ? edu.courses.join(', ')
            : edu.courses
          }`,
      })
    )
  }
  if (edu.score) {
    item.push(
      new Paragraph({
        text: `GPA: ${edu.score}`,
      })
    )
  }
  return item
}

export default education
